export const timeFormat = (duration) => {
  // Hours, minutes and seconds
  const hrs = ~~(duration / 3600);
  const mins = ~~((duration % 3600) / 60);
  const secs = ~~duration % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = "";

  if (hrs > 0) {
    ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  }

  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;

  return ret;
};

export const getRestTime = (set, user) => {
  if (set.restTime) {
    return timeFormat(set.restTime);
  } else if (
    set.reps &&
    user.restTime?.reps[`rep${set.reps >= 12 ? 12 : set.reps}`]
  ) {
    return timeFormat(
      user.restTime?.reps[`rep${set.reps >= 12 ? 12 : set.reps}`]
    );
  } else if (user.restTime?.default) {
    return timeFormat(user.restTime.default);
  }
  return "-";
};

export const getSecondsAndMinutes = (duration) => {
  if (!duration) return [0, 0];
  const minutes = ~~((duration % 3600) / 60);
  const seconds = ~~duration % 60;
  return [seconds, minutes];
};

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  if (minutes > 0) {
    if (remainingSeconds > 0) {
      return `${minutes}${minutes > 1 ? "mins" : "min"} ${remainingSeconds}sec`;
    } else {
      return `${minutes}${minutes > 1 ? "mins" : "min"}`;
    }
  } else {
    return `${remainingSeconds}sec`;
  }
};

export const getMinutesAndHours = (duration) => {
  if (!duration) return [0, 0];
  const totalMinutes = Math.floor(duration / (1000 * 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return [hours, minutes];
};
